// The customer journey's application and review screens (slice 2, doc 13
// §5a). Relative child paths under the registration module. No meta.section:
// that would switch on the legacy maker-checker header.
const customerApplicationRoutes = [
  // slice 1 name: the inbox is now the Pending page's "Awaiting approval" list
  {
    name: "customerJourneyInbox",
    path: "customer-journey/inbox",
    redirect: { name: "memberPending", query: { show: "approval" } },
  },

  // create and resume an application, individual or group (the maker)
  {
    name: "customerApplicationWorkspace",
    path: "applications/:id",
    component: () => import("./ApplicationFlow.vue"),
    meta: {
      auth: true,
      title: "Member Application",
      breadcrumb: "Member Application",
      permission: ["create member"],
    },
  },

  // the review of an application: the permissions of
  // GET /customer-applications/{id}. A maker holding only "create member"
  // sees their own applications; the server answers 404 for anyone else's.
  // The decision buttons follow the server's actions flags.
  {
    name: "applicationReview",
    path: "applications/:id/review",
    component: () => import("../Review/ApplicationReviewFlow.vue"),
    meta: {
      auth: true,
      title: "Review Application",
      breadcrumb: "Review Application",
      permission: ["view member applications", "approve member", "create member"],
    },
  },

  // the permissions of GET /change-requests/{id}. A maker holding only
  // "update member" sees their own change requests; the server answers 404
  // for anyone else's.
  {
    name: "changeRequestReview",
    path: "change-requests/:id",
    component: () => import("../Review/ChangeRequestReview.vue"),
    meta: {
      auth: true,
      title: "Change Request",
      breadcrumb: "Change Request",
      permission: ["view member applications", "approve member", "update member"],
    },
  },
];

export default customerApplicationRoutes;
